import {
  Grid,
  LinearProgress,
  makeStyles,
  Paper,
  Popover,
  Typography,
  withStyles
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { ReactComponent as ShareButtonSvg } from '../../../../images/share-btn.svg';
import { isRetrievalTag } from '../../../../utils/tagValidatorUtils';
import {
  getProgress,
  secondsToHms,
  truncateText
} from '../../../../utils/utils';
import RetrievalFeedback from '../../../flags/components/RetrievalFeedback';
import '../../styles/dashboard-sidebar.css';
import { isUnmatchedFlag } from '../../../../utils/isUnmatchedFlag';
import { secondsToHmsCheck } from '../../../../utils/secondsToHmsCheck';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '8px!important',
      backgroundColor: '#D9D9D9!important'
    },

    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#8B8E94!important',
      borderRadius: '4px!important'
    }
  }
}));

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 4,
    borderRadius: 5,
    marginTop: 4,
    marginBottom: 4
  },
  colorPrimary: {
    backgroundColor: '#EDEEEFD1'
  },
  bar: {
    borderRadius: 5,
    backgroundColor: 'var(--color-ai-green)'
  }
}))(LinearProgress);

const DashboardSidebar = ({
  last5Documents,
  isPaused,
  playingDocumentId,
  last5Flags,
  notifications,
  onClickLastListened,
  onRowClickFlag,
  openShareModal
}) => {
  const classes = useStyles();

  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const [showAll, setShowAll] = useState(false);

  const [showAllNotifications, setShowAllNotifications] = useState(false);

  const [showPopover, setShowPopover] = useState(null);

  const [currentNotification, setCurrentNotification] = useState(null);

  const formatReleaseDate = (dateString) => {
    const date = new Date(dateString);
    const options = { month: 'short', day: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  };

  const handleShowAllFlags = () => {
    setShowAll(!showAll);
  };

  const handleShowAllNotifications = () => {
    setShowAllNotifications(!showAllNotifications);
  };

  const handleShareFlag = (flag) => {
    const myFlag = { ...flag, flagId: flag.id };
    openShareModal(myFlag);
  };

  const renderFlags = () => {
    if (last5Flags?.length > 3) {
      if (showAll) {
        return last5Flags;
      } else {
        return last5Flags.slice(0, 3);
      }
    }
    return last5Flags;
  };

  const renderNotifications = () => {
    const array = notifications?.notifications;
    array?.sort(function(a, b) {
      return new Date(b.timestamp) - new Date(a.timestamp);
    });
    if (array?.length > 3) {
      if (showAllNotifications) {
        return array;
      } else {
        return array.slice(0, 3);
      }
    }
    return array;
  };

  const renderDocumentImage = (icon, itemId) => {
    return (
      null
    )
    };

  const onHoverNotification = (e, notification) => {
    setShowPopover(e.currentTarget);
    setCurrentNotification(notification.id);
    setTimeout(() => {
      onLeaveNotification();
    }, 2500);
  };

  const onLeaveNotification = () => {
    setShowPopover(null);
    setCurrentNotification(null);
  };

  const open = Boolean(showPopover);
  const id = open ? `popover-${currentNotification}` : undefined;

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });

  return (
    <Grid container component="section">
      <Grid item xs={12} className="last-flags-widget sidebar-widget panel-24">
        <div className="sidebar-widget__header last-flags-widget__heade panel-24r">
          <h3 className="last-flags-widget__header-title">Recent Flags</h3>
        </div>
        <Grid
          container
          className="sidebar-widget__body last-flags-widget__body"
        >
          {renderFlags().map((lastFlagItem) => (
            <Grid
              item
              xs={12}
              key={lastFlagItem.id}
              component="div"
              className="sidebar-widget__body-item last-flags-widget__body-item"
            >
              <div
                className="last-flags-widget__body-left"
                onClick={() =>
                  !isUnmatchedFlag(lastFlagItem.trackPosition) &&
                  onRowClickFlag(lastFlagItem, false)
                }
              >
                {renderDocumentImage(lastFlagItem.flag.icon, lastFlagItem.id)}
                <div className="sidebar-widget__body-content last-flags-widget__body-content panel-24">
                  <h5 className="flag-title">
                    {`${lastFlagItem.name}:`}
                    <span className="duration" style={{ padding: '0 5px' }}>
                      {`(${secondsToHmsCheck(lastFlagItem.trackPosition)})`}
                    </span>{' '}
                    - {formatReleaseDate(lastFlagItem.releaseDate)}
                  </h5>
                  <span className="flag-description">
                    {truncateText(
                      lastFlagItem.text,
                      windowSize <= 991 ? 150 : 50
                    )}
                  </span>
                  {lastFlagItem?.dictation &&
                    (isRetrievalTag(lastFlagItem?.tag) ? (
                      <RetrievalFeedback
                        tag={lastFlagItem?.tag}
                        dictation={lastFlagItem?.dictation}
                        source="recentFlags"
                      />
                    ) : (
                      <div className="flag-dictation">
                        <span className="flag-dication-text">
                          {lastFlagItem.dictation}
                        </span>
                      </div>
                    ))}
                </div>
              </div>
              {lastFlagItem.isShareable &&
                !isRetrievalTag(lastFlagItem.tag) &&
                !lastFlagItem.isOwner &&
                !isUnmatchedFlag(lastFlagItem.trackPosition) && (
                  <span
                    className="flag-share"
                    onClick={() => handleShareFlag(lastFlagItem)}
                  >
                    <ShareButtonSvg fill="#EDEEEF" />
                  </span>
                )}
            </Grid>
          ))}
        </Grid>
        {last5Flags?.length > 3 ? (
          <div className="sidebar-widget__footer">
            <span className="show-more-less" onClick={handleShowAllFlags}>
              {showAll ? 'See Less...' : 'See All...'}
            </span>
          </div>
        ) : (
          ''
        )}
      </Grid>
      {notifications?.notifications?.length > 0 ? (
        <Grid
          item
          xs={12}
          className="last-flags-widget sidebar-widget panel-24"
        >
          <div className="sidebar-widget__header last-flags-widget__header">
            <h3 className="last-flags-widget__header-title">Notifications</h3>
          </div>
          <Grid
            container
            className="sidebar-widget__body last-flags-widget__body"
          >
            {renderNotifications()?.map((notification) => (
              <Grid
                item
                xs={12}
                key={notification.id}
                component="div"
                className="sidebar-widget__body-item last-flags-widget__body-item"
              >
                <div
                  className="last-flags-widget__body-left"
                  onClick={() => onRowClickFlag(notification, true)}
                >
                  <div className="label-container">
                    <div>
                      <span
                        className="label-title"
                        style={{ fontWeight: 'bold' }}
                      >
                        {notification.sourceUserFullName}{' '}
                        <span style={{ fontWeight: 100, fontSize: 16 }}>
                          sent {formatReleaseDate(notification.timestamp)}
                        </span>
                      </span>
                      <div
                        className="label-details__users"
                        style={{ lineHeight: '16px' }}
                        onMouseOver={(e) =>
                          onHoverNotification(e, notification)
                        }
                        aria-describedby={id}
                      >
                        <span className="duration">{` [${secondsToHms(
                          notification.trackPosition
                        )}]`}</span>{' '}
                        <span className="flag-description">
                          {truncateText(
                            notification.transcriptText,
                            windowSize <= 991 ? 150 : 80
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <Popover
                  id={`popover-${notification.id}`}
                  open={open && currentNotification === notification.id}
                  anchorEl={showPopover}
                  onClose={onLeaveNotification}
                  anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right'
                  }}
                  transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left'
                  }}
                >
                  <Paper
                    className={classes['@global']}
                    style={{
                      maxHeight: 200,
                      maxWidth: 400,
                      overflow: 'auto',
                      padding: 5
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: 13,
                        fontFamily: ' "Proxima Nova", sans-serif'
                      }}
                      dangerouslySetInnerHTML={{
                        __html: notification.transcriptText
                      }}
                    />
                  </Paper>
                </Popover>
              </Grid>
            ))}
          </Grid>
          {notifications?.notifications?.length > 3 ? (
            <div className="sidebar-widget__footer">
              <span
                className="show-more-less"
                onClick={handleShowAllNotifications}
              >
                {showAllNotifications ? 'See Less...' : 'See All...'}
              </span>
            </div>
          ) : (
            ''
          )}
        </Grid>
      ) : (
        <></>
      )}
      <Grid
        item
        xs={12}
        className="last-listened-widget sidebar-widget panel-24"
      >
        <div className="last-listened-widget__header sidebar-widget__header">
          <h3 className="last-listened-widget__header-title">In Progress</h3>
        </div>
        <Grid
          container
          className="sidebar-widget__body last-listened-widget__body"
        >
          {last5Documents?.map((lastListenedItem) => (
            <Grid
              key={lastListenedItem.id}
              item
              xs={12}
              component="div"
              className="sidebar-widget__body-item last-listened-widget__body-item"
              onClick={() => onClickLastListened(lastListenedItem)}
            >
              {renderDocumentImage(
                lastListenedItem?.document?.icon,
                lastListenedItem.id
              )}
              <div className="sidebar-widget__body-content last-listened-widget__body-content">
                <h5 className="document-title">
                  {`${lastListenedItem.document.name}:`}
                  <span className="duration">{` (${secondsToHms(
                    lastListenedItem.document.duration
                  )})`}</span>{' '}
                  - {formatReleaseDate(lastListenedItem.releaseDate)}
                </h5>
                <span className="document-description">
                  {truncateText(
                    lastListenedItem.document.description,
                    windowSize <= 991 ? 150 : 80
                  )}
                </span>
                <BorderLinearProgress
                  variant="determinate"
                  value={getProgress(
                    lastListenedItem.document.progress,
                    lastListenedItem.document.duration
                  )}
                />
              </div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DashboardSidebar;
